import React, { FunctionComponent, ComponentProps } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './GridItem.module.css';

export type GridItemProps = ComponentProps<'div'> & {
  size: GridItemSize;
};

export const GridItem: FunctionComponent<GridItemProps> = React.memo(
  (props) => {
    const { children, size, className, ...remainingProps } = prepareProps({
      props
    });
    return (
      <div
        {...remainingProps}
        className={classes(className, getSizeClassName(size))}
      >
        {children}
      </div>
    );
  }
);

export type GridItemSize = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

function getSizeClassName(size: GridItemSize): string {
  const className = (styles as any)[`size${size}`];

  if (!className) {
    throw new Error(`size "${size}" is not supported. No className found.`);
  }

  return className;
}
